(function() {
  const selector = '.real-top-bar .promo-shipping .real-shipping';
  const bar = document.querySelector(selector);
  if (!bar) return;

  const originalHTML = bar.innerHTML;

  // ---- Surfboards page detection ----
  const isSurfboards = window.location.pathname.includes("surfboards");

  // Grab the wrapper div and the link inside it
  const sidebarWrapper = isSurfboards ? document.querySelector('.sidebar--sale-bf') : null;
  const sidebarLink = sidebarWrapper ? sidebarWrapper.querySelector('a') : null;

  // Only update sidebar once
  let sidebarUpdated = false;

  const saleEnd = new Date('2025-12-02T00:00:00-05:00').getTime();
  


  function pad(n) {
    return n < 10 ? "0" + n : n;
  }

  function update() {
    const now = Date.now();
    const diff = saleEnd - now;

    // ---- Countdown expired ----
    if (diff <= 0) {
      bar.innerHTML = originalHTML;
      document.body.classList.remove("csm-active");
      clearInterval(interval);
      return;
    }

    // ---- Countdown active ----
    document.body.classList.add("csm-active");

    // ---- Update sidebar ONCE only ----
    if (!sidebarUpdated && sidebarWrapper && sidebarLink) {
      sidebarWrapper.classList.remove("sidebar--sale-bf");
      sidebarLink.textContent = "On Sale";
      sidebarUpdated = true;
    }

    let hours = Math.floor(diff / 1000 / 60 / 60);
    let mins = Math.floor((diff / 1000 / 60) % 60);
    let secs = Math.floor((diff / 1000) % 60);

    bar.innerHTML = `
      <div class="csm-banner-countdown">
        <strong>CYBER SURFBOARD MONDAY</strong> &bull; ENDS IN

        <span class="wrapper--real-cyber-cards">
          <span class="real-cyber-cards">
            <span class="real-cyber-card">${hours}H</span>
            <span class="real-cyber-card">${pad(mins)}M</span>
            <span class="real-cyber-card">${pad(secs)}S</span>
          </span>
        </span>

        <a href="/collections/surfboards" class="btn btn-outline-csm-primary btn-sm text-uppercase">Shop surfboards</a> 
        <a href="/collections/surfboards" class="h5 underline text-uppercase">Shop surfboards</a>
      </div>
    `;
  }

  update();
  const interval = setInterval(update, 1000);
})();


document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.csm-pulse-wrapper');
  
  if (wrapper) {
    
    // --- START SHAKING FUNCTION ---
    function startShake(event) {
      // Prevents the default action, which on mobile includes the save/share menu
      event.preventDefault(); 
      wrapper.classList.add('is-shaking');
    }
    
    // --- STOP SHAKING FUNCTION ---
    function stopShake(event) {
      // Prevents default behavior on release, if needed
      if (event) {
        event.preventDefault();
      }
      wrapper.classList.remove('is-shaking');
    }
    
    // 1. Mouse Events (Desktop)
    wrapper.addEventListener('mousedown', startShake);
    wrapper.addEventListener('mouseup', stopShake);
    
    // 2. Touch Events (Mobile)
    wrapper.addEventListener('touchstart', startShake);
    wrapper.addEventListener('touchend', stopShake);
    
    // 3. Prevent context menu on long press (Crucial for iOS)
    wrapper.addEventListener('contextmenu', function(e) {
        e.preventDefault(); 
    });
  }
});